<template>
    <Window ref="generic"/>
</template>

<script>
import Window from "./components/layouts/Window";

export default {
    components: {Window},
    mixins: [nccregistrarMixin],
    created() {

    },
};
</script>
<style lang="scss" scoped>
.page-base #app {
    display: none;
}

#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: var(--primary-font);
}
</style>
